const options = {
  5: "bg-violet-50/5",
  10: "bg-violet-50/10",
  25: "bg-violet-50/25",
  50: "bg-violet-50/50",
  75: "bg-violet-50/75",
  90: "bg-violet-50/90",
  100: "bg-violet-50",
};

const from = {
  5: "from-violet-50/5",
  10: "from-violet-50/10",
  25: "from-violet-50/25",
  50: "from-violet-50/50",
  75: "from-violet-50/75",
  90: "from-violet-50/90",
  100: "from-violet-50",
};

export default function getBackgroundViolet50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
